import { render, staticRenderFns } from "./CoWeekdayCircle.vue?vue&type=template&id=0c0dc10e&scoped=true&"
import script from "./CoWeekdayCircle.vue?vue&type=script&lang=ts&"
export * from "./CoWeekdayCircle.vue?vue&type=script&lang=ts&"
import style0 from "./CoWeekdayCircle.vue?vue&type=style&index=0&id=0c0dc10e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0dc10e",
  null
  
)

export default component.exports